import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Capability from './Capability';
const Capabilities = ({ capabilities })=>/*#__PURE__*/ _jsx("table", {
        className: "section__table mt-4",
        children: /*#__PURE__*/ _jsx("tbody", {
            className: "section__table__body",
            children: capabilities.map((capability)=>/*#__PURE__*/ _jsx(Capability, {
                    capability: capability
                }, capability.externalDataSourceCapabilityId))
        })
    });
export default Capabilities;
